<template>
  <div id="adg_supermercado">
    <div class="portada-portafolio">
      <div class="subportada-portafolio d-flex align-items-center justify-content-center flex-wrap">
        <div>
          <h1>Hostelería</h1>
        </div>
      </div>
    </div>
    <div class="contenido">
      <div class="py-5 row w-100 mx-auto">
        <div class="contenedor-texto col-12 pb-4 mb-1">
          <div>
            <titulo-seccion>
              La mejor solución para administrar cafeterías, restaurantes, pizzerías, fast food, discoteca, colectividades
              o catering.
            </titulo-seccion>
            <p class="pt-3">
              Con ADG Hostelería puedes optimizar los procesos de venta como nunca antes y aumentar tus beneficios
              hasta las nubes.
            </p>
          </div>
        </div>

        <!-- ------------------ Caracteristicas ------------------ -->
        <div class="col-12">
          <div class="row w-100 mx-auto justify-content-center pb-3">
            <div class="col-12">
              <titulo-seccion class="pb-2">Obtén ventajas</titulo-seccion>
              <p>Adquiere esta solución y disfruta de increíbles ventajas.</p>
            </div>
            <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
              <div class="contenedor-icono">
                <i class="fas fa-tags"></i>
              </div>
              <h3 class="mt-3 mb-1">Ventas</h3>
              <p>Aumenta el promedio de ventas.</p>
            </div>

            <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
              <div class="contenedor-icono">
                <i class="fas fa-clock"></i>
              </div>
              <h3 class="mt-3 mb-1">Tiempo</h3>
              <p>Optimiza el tiempo de todos los procesos.</p>
            </div>

            <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
              <div class="contenedor-icono">
                <i class="fas fa-users"></i>
              </div>
              <h3 class="mt-3 mb-1">Clientes</h3>
              <p>Incrementa la frecuencia de nuevos clientes.</p>
            </div>
          </div>
        </div>
        <!-- ------------------ Caracteristicas ------------------ -->

        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/hosteleria/ventas.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Gestiona tus ventas</h2>
            <p>Administra las ordenes y ventas con una interfaz sencilla para optimizar el tiempo de venta de tus cajas.</p>
          </div>
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Gestiona reservas</h2>
            <p>Facilita la gestión de las reservas que realizan los clientes.</p>
          </div>
        </div>

        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/hosteleria/reservas.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/hosteleria/clientes.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Fideliza tus clientes</h2>
            <p>Haz los clientes se vuelvan fieles a tu hostelería con nuestro sistema de fidelización.</p>
          </div>
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Administre su almacén</h2>
            <p>Controle la existencia, orden, precios, costos y más de los productos de su almacén para tenerlo completamente optimizado.</p>
          </div>
        </div>

        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/hosteleria/almacen.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-img col-12 col-md-6 my-2">
          <img
            class="shadow-sm"
            src="@/assets/images/productos/domit/hosteleria/pedidos.jpeg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-2">
          <div>
            <h2>Administre sus pedidos</h2>
            <p>Controle los procesos de cobro y estados de los pedidos a domicilio.</p>
          </div>
        </div>
        <!-- Caracteristicas -->
        <!-- --------------- -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
#adg_supermercado {
  min-height: 100vh;
}
.portada-portafolio {
  height: 50vh;
  width: 100%;
  color: white;
  background: #262626;  
  background: url("../../../assets/images/productos/domit/hosteleria.jpeg");
  background-size: cover;
}
.portada-portafolio h1 {
  font-size: calc(3.5em + 1vh);
  letter-spacing: -0.5px;
}
.portada-portafolio h2 {
  font-size: 2em;
}
.portada-portafolio h2,
h1 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.subportada-portafolio {
  background: rgba(0, 0, 0, 0.35);
  height: 100%;
  width: 100%;
}
.contenido {
  padding: 0 6%;
}
.contenedor-texto {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.contenedor-icono {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
  width: 100px;
  margin: auto;
  height: 100px;
  border-radius: 200px;
  color: #262626;
  border: 5px solid #262626;
  font-size: 3.1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
p {
  padding-top: 15px;
  color: #595959;
  font-size: calc(0.9em + 0.3vw);
}

@media screen and (max-width: 768px) {
  p {
    font-size: calc(1em + 0.3vw);
  }
}
</style>